import {PageView} from "./PageView.js";
import {UserProfileLayout} from "../components/layout/UserProfileLayout.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {
    addJobType,
    addPassword,
    addUserName,
     getUser,
    getUserId, getUserName,
    isGuestUser,
    isSnsSignUp
} from "../store.js";
import {PasswordInput} from "../components/input/PasswordInput.js";
import {NameInput} from "../components/input/NameInput.js";
import {UserJobTitleSelect} from "../components/select/UserJobTitleSelect.js";
import {Header} from "../components/Header.js";
import {TermPopup} from "../components/popup/TermPopup.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";

export class UserProfileView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        const userId = getUserId();
        this.$props.UserProfileLayout = new UserProfileLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            userId,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.nextPage.bind(this)
            }
        });
    }

    renderComponents() {
        if(!this.$props.UserProfileLayout) {
            return;
        }
        // 패스워드 입력 태그 추가
        new Header(this.$props.UserProfileLayout.getHeaderLayer(), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });

        // 이름 입력 태그 추가
        this.$props.NameInput = new NameInput(this.$props.UserProfileLayout.getUserNameLayer(), {
            isLast: Often.isGlobal(),
            addClassName: this.getCommonJoinInputClassName(),
            submit : this.nextPage.bind(this),
            value : isSnsSignUp() ? getUserName() : ""
        });

        this.$props.PasswordInput = !isSnsSignUp() ? new PasswordInput(this.$props.UserProfileLayout.getPasswordLayer(), {
            allowBlank: false,
            addClassName: this.getCommonJoinInputClassName()
        }) : null;


        //유저 업종 셀렉터 태그 추가 (Sns는 flow_User 테이블이 없어서 저장할 수 없다. )
        this.$props.UserJobTitleSelect =   new UserJobTitleSelect(this.$props.UserProfileLayout.getJobSelectorLayer(), {
            addClassName: this.getCommonJoinInputClassName()
        }) ;
    }

    getSectionId() {
        return `profileInputSection`;
    }

    getCommonJoinInputClassName() {
        return `js-join-input`
    }
    async nextPage() {
        const $profileInputSection = $(`#${this.getSectionId()}`);
        const $profileInputs = $profileInputSection.find(`.${this.getCommonJoinInputClassName()}`);
        if (!InputValidator.inputsValidate($profileInputs)) {
            return;
        }
        this.addUserInfo();
        if(!Often.isGlobal()) {
            new TermPopup($profileInputSection, {
                isAppend : true,
            });
            return;
        }

        if(isGuestUser()) {
            Mutil.mlog("게스트 유저는 해당 페이지로 올 수 없습니다.");
            return;
        }

        new LoadingPopup(this.$props.UserProfileLayout.getMainArticle(), {
            isAppend: true,
            loadingText : i18next.t(common.wait)
        });
        const inviterList = await getUser().getInviterList();
        if(inviterList.length === 0) {
            SignUpViewChanger.loadCompanyInfoInputView();
            return;
        }
        SignUpViewChanger.loadCompanyInviteView(inviterList);
    }

    addUserInfo() {
        addUserName(this.$props.NameInput.getInputValue());
        if(this.$props?.UserJobTitleSelect !== null) {
            addJobType(this.$props.UserJobTitleSelect.getSelectValue());
        }

        if (this.$props?.PasswordInput !== null) {
            addPassword(this.$props.PasswordInput.getInputValue());
        }
    }

}

